module.exports = __webpack_public_path__ + "static/media/1.b0474bf0.jpeg";